import { lazy } from "react";
import { Route } from "./types";
import ROUTE_CONSTANTS from "./routeConstants";
const Login = lazy(() => import("../screens/LoginScreen"));
const PageNotFound = lazy(() => import("../screens/PageNotFoundScreen"));
const OperationUserDashboard = lazy(
  () => import("../../operationUser/screens/OperationUserdashboard")
);
const RoleNotFound = lazy(() => import("../screens/NoRolesFoundScreen"));
const RoleManagement = lazy(
  () => import("../../operationUser/screens/RoleManagementScreen")
);
const MemberManagement = lazy(
  () => import("../../operationUser/screens/MemberManagementScreen")
);
const OperationUserManagement = lazy(
  () => import("../../operationUser/screens/OperationUserManagementScreen")
);
const AddEditOperationUser = lazy(
  () => import("../../operationUser/screens/AddEditOperationUserScreen")
);
const AddEditMember = lazy(
  () => import("../../operationUser/screens/AddEditMemberScreen")
);
const AddEditRole = lazy(
  () => import("../../operationUser/screens/AddEditRoleScreen")
);
const AddEditAdvertisement = lazy(
  () => import("../../operationUser/screens/AddEditAdvertisementScreen")
);
const AdvertisementManagement = lazy(
  () => import("../../operationUser/screens/AdvertisementManagementScreen")
);
const AddEditEvent = lazy(
  () => import("../../operationUser/screens/AddEditEventScreen")
);
const EventManagement = lazy(
  () => import("../../operationUser/screens/EventManagementScreen")
);
const EventDetails = lazy(
  () => import("../../operationUser/screens/EventDetailsScreen")
);
const MemberDetails = lazy(
  () => import("../../operationUser/screens/MemberDetailsScreen")
);
const ApproveMemberDetails = lazy(
  () => import("../../operationUser/screens/MemberDetailsApprovalScreen")
);

const {
  ADD_EDIT_ADVERTISEMENT,
  ADVERTISEMENT_MANAGEMENT,
  ADD_EDIT_EVENT,
  APPROVE_MEMBER_DETAILS,
  EVENT_MANAGEMENT,
  ADD_EDIT_MEMBER,
  ADD_EDIT_OPERATION_USER,
  ADD_EDIT_ROLE,
  DASHBOARD,
  LOGIN,
  NO_ROLE_PAGE,
  NOT_FOUND,
  ROLE_MANAGEMENT,
  OPERATION_USER_MANAGEMENT,
  MEMBER_MANAGEMENT,
  EVENT_DETAILS,
  MEMBER_DETAILS,
} = ROUTE_CONSTANTS;

export const OPERATION_USER_SIDEBAR_OPTIONS: Route[] = [
  {
    url: ROLE_MANAGEMENT,
    name: "Role Management",
    sequenceNumber: 1,
    component: <RoleManagement />,
  },
  {
    url: OPERATION_USER_MANAGEMENT,
    name: "Operation User Management",
    sequenceNumber: 2,
    component: <OperationUserManagement />,
  },
  {
    url: MEMBER_MANAGEMENT,
    name: "Member Management",
    sequenceNumber: 3,
    component: <MemberManagement />,
  },
  {
    url: ADVERTISEMENT_MANAGEMENT,
    name: "Advertisment Management",
    sequenceNumber: 4,
    component: <AdvertisementManagement />,
  },
  {
    url: EVENT_MANAGEMENT,
    name: "Event Management",
    sequenceNumber: 5,
    component: <EventManagement />,
  },
];

const OPERATION_USER_ROUTES: Route[] = [
  {
    url: DASHBOARD,
    component: <OperationUserDashboard />,
  },
  {
    url: ADD_EDIT_OPERATION_USER,
    component: <AddEditOperationUser />,
  },
  {
    url: ADD_EDIT_MEMBER,
    component: <AddEditMember />,
  },
  {
    url: ADD_EDIT_ROLE,
    component: <AddEditRole />,
  },
  {
    url: ADD_EDIT_ADVERTISEMENT,
    component: <AddEditAdvertisement />,
  },
  {
    url: ADD_EDIT_EVENT,
    component: <AddEditEvent />,
  },
  {
    url: EVENT_DETAILS,
    component: <EventDetails />,
  },
  {
    url: MEMBER_DETAILS,
    component: <MemberDetails />,
  },
  {
    url: APPROVE_MEMBER_DETAILS,
    component: <ApproveMemberDetails />,
  },
];

const MEMBER_SIDEBAR_OPTIONS: Route[] = [];

const MEMBER_ROUTES: Route[] = [];

const MISC_ROUTES: Route[] = [
  {
    url: NO_ROLE_PAGE,
    component: <RoleNotFound />,
    displaySidebar: false,
  },
  {
    url: NOT_FOUND,
    component: <PageNotFound />,
  },
];

export const UNAUTHENTICATED_ROUTES: Route[] = [
  {
    url: LOGIN,
    component: <Login />,
    displaySidebar: false,
  },
];

export const AUTHENTICATED_ROUTES: Route[] = [
  ...MEMBER_SIDEBAR_OPTIONS,
  ...MEMBER_ROUTES,
  ...OPERATION_USER_SIDEBAR_OPTIONS,
  ...OPERATION_USER_ROUTES,
  ...MISC_ROUTES,
];
